// TODO: remove this once we have a way to import the Select component
// bend-lint-disable-next-line strict-exports
import { Select } from 'foundations-components/transitional/components/Select/Select';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useSearchParams } from '../../../hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SelectFilter({
  filter,
  multi = false
}) {
  const params = useSearchParams();
  if (!filter) return null;
  const id = `eco_${filter.field}`;
  const getter = multi ? params.getList : params.get;
  const setter = multi ? params.setList : params.set;

  // support both flat and grouped options
  const options = filter.options.length > 0 ? [...filter.options] // spreading fixes readonly issue
  : filter.optionGroups.map(optionGroup => ({
    text: optionGroup.subheading,
    options: optionGroup.options
  }));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [filter.label && /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: id,
      marginBlockStart: "200",
      children: filter.label
    }), /*#__PURE__*/_jsx(Select, {
      clearable: true,
      id: id,
      multi: multi,
      onChange: e => setter(filter.field, e.target.value),
      options: options,
      placeholder: filter.placeholder,
      value: getter(filter.field)
      // TODO: remove this hack after talking with Trellis team
    }, multi ? undefined : getter(filter.field))]
  });
}